<template>
  <span :class="spacer.style">
    <template v-for="index in spacer.size">
      <div :key="index">.</div>
    </template>
  </span>
</template>

<script>
export default {
  name: "Spacer",
  props: ["spacer"]
};
</script>